import { useState, useEffect, useMemo } from 'react'
import Modal from '../Modal'
import SetAlertPanel from './SetAlertPanel'
import { Button } from '@mui/material'
import { useProject } from '../../context/project'
import { useGeneral } from '../../context/general'
import { getDatasetFrequency, getDisableGroupByOptions } from '../../utils/aggregationUtils'
import useAlerts from '../../hooks/useAlerts'

const options = {
    type: [
        { name: 'Dataset trend' , value: 'datasetTrend' }
    ],
}

export default function AlertModal({open, closeMenu, form, setForm, alertToEdit, emptyForm}) {
    const [ originalFrequency, setOriginalFrequency ] = useState('')
    const [currentDataset, setCurrentDataset] = useState({})
    const { dataset, datasets, getColumns, ticker } = useProject()
    const { createNewAlert, editAlert } = useAlerts()
    const { setPopupAlert } = useGeneral()

    const columns = useMemo(() => currentDataset.datasetValue && getColumns(currentDataset.datasetValue), [currentDataset.datasetValue, getColumns])

    useEffect(() => {
        if(form.selectedDataset) {
            const frequency = getDatasetFrequency(datasets, form.selectedDataset.datasetValue)
            setForm(form)
            setOriginalFrequency(frequency)
        }

        return () => setForm(emptyForm)
    }, [form.selectedDataset]) // eslint-disable-line

    const editAlertInModal = () => {
        const frequency = getDatasetFrequency(datasets, alertToEdit.dataset)
        setOriginalFrequency(frequency)
        setCurrentDataset({datasetName: alertToEdit.datasetName, datasetValue: alertToEdit.dataset})

        const newForm ={
            alertType: "datasetTrend",
            selectedDataset: {
                columnValue:alertToEdit.column, 
                columnName:alertToEdit.columnName, 
                datasetValue:alertToEdit.dataset, 
                datasetName:alertToEdit.datasetName
            },
            change: alertToEdit.change,
            timePeriod: alertToEdit.time_period,
            agg:alertToEdit.agg
        } 
        setForm(newForm)
    }

    useEffect(() => {
        if (alertToEdit){
            editAlertInModal()
        }
        return () => {}
    }, [alertToEdit]) // eslint-disable-line

    const groupByOptions = useMemo(() => originalFrequency ? getDisableGroupByOptions(originalFrequency) : [],[originalFrequency])

    const submitForm = () => {
        form['timePeriod'] = form['timePeriod'] || originalFrequency
        if (form.selectedDataset.columnValue && !alertToEdit){
            if (form.change_1){
                const change_1 = form.change_1
                delete form.change_1
                const secondForm = {...form}
                secondForm.change = change_1
                createNewAlert(secondForm, ticker)
            }
            createNewAlert(form, ticker)
            closeMenu()
        } else if (form.selectedDataset.columnValue && alertToEdit) {
            editAlert({...form, 
                uuid: alertToEdit.uuid, 
                columnName:form.selectedDataset.columnName, 
                datasetName:form.selectedDataset.datasetName,
                time_period: form.timePeriod,  
                column:form.selectedDataset.columnValue, 
                dataset:form.selectedDataset.datasetValue,
            })
            closeMenu()
        }else {
            setPopupAlert('error', 'Cannot create alert, there are fields empty.')
        }
    }

    const updateField = (value) => {
        const newForm = {...form}
        newForm[value.name] = value.value
        setForm(newForm)
    }

    const buttons = [
        <Button key="cancel" color='inherit' onClick={closeMenu}>Cancel</Button>,
        <Button key="set-alert" variant="contained" color="active" onClick={submitForm}>{alertToEdit ? 'Update Alert' : "Set Alert"}</Button>,
    ]

    const alertProps = {form, updateField, originalFrequency, options, groupByOptions}

    const datasetButtonProps = {dataset, index: 0, columns}

    const changeColumn = (columnValue,columnName,dataset) => {
        if(dataset){
            setCurrentDataset({datasetValue:dataset.value,datasetName:dataset.name})
            setForm((state) => ({ ...state, selectedDataset: {columnValue, columnName,datasetName:dataset.name,datasetValue:dataset.value} }))
        }
        else
        {
            setForm((state) => ({ ...state, selectedDataset: {...state.selectedDataset, columnValue, columnName} }))
        }
    }

    const changeDataset = (datasetValue,datasetName) => {
        setCurrentDataset({datasetValue,datasetName})
        setForm((state) => ({ ...state, selectedDataset: {columnValue:'', columnName:'', datasetValue, datasetName} }))
    }

    const dropdownDatasetProps = { changeColumn, changeDataset, datasets } 

    return (
        <Modal open={open} handleClose={closeMenu} title={alertToEdit ? 'Edit Alert' : "Set New Alert"} buttons={buttons}>
            <SetAlertPanel {...alertProps} datasetButtonProps={datasetButtonProps} alertToEdit={alertToEdit} {...dropdownDatasetProps}/>
        </Modal>
    )
}